// extracted by css-extract-rspack-plugin
export default {"root":"root-MLeQr6","svg":"svg-BwFRcH","svgisExpanded":"svgisExpanded-fHsD0k"};